import React from 'react';
import './membership.css';
import Bookmark from '../../bookmark/Bookmark';
import { FaCheckCircle } from 'react-icons/fa';
import { membership_data } from './membershipData';

const Membership = () => {
	return (
		<React.Fragment>
			<div className="background-img-membership">
				<div className="membership-discount-container">
					<div className="membership-typography-container">
						<h1 className="membership-discount-typography">20% off All Memberships</h1>
						<h3 className="limited-time-only-typography">Limited Time Only</h3>
					</div>
				</div>
			</div>
			<h1 className="chooose-membership-typography">Choose a Membership</h1>
			<div className="membership-bookmark-container">
				<table className="membership-table">
					<tbody>
						<tr>
							<th className="table-header-empty" />
							<th className="table-header-empty" />
							<th className="table-header-best-value-typography">Recommend</th>
						</tr>
						<tr>
							<th className="table-header-empty"> </th>
							{membership_data.map((item, id) => {
								return (
									<th className="table-header-typography" key={id}>
										{item.membership}
										<div className="membership-table-price-container">
											<div className="membership-table-price-typography">{item.price}</div>
											<div className="membership-table-sale-typography">{item.sale()}</div>
										</div>
									</th>
								);
							})}
						</tr>

						<tr>
							<th className="perks-typography">Unlimited Accsss to Home Club</th>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">Free Fitness Training</th>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">Free Wifi</th>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">Bring a Guest Anytime</th>
							<td />
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">Use of Tanning</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">50% Off Drinks</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">Worldwide Travel Deals</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">20% off at Nike.com</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">20% off at Adidas.com</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">20% off at UnderArmor.com</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
						<tr>
							<th className="perks-typography">20% off at Gymshark.com</th>
							<td> </td>
							<td>
								<FaCheckCircle className="checkmark-icon" />
							</td>
						</tr>
					</tbody>
				</table>
				<div className="table-2">
					{membership_data.map((item) => {
						return (
							<Bookmark key={item.id}>
								<div>
									<div className="membership-type-container">
										<h1 className="membership-type-typography">{item.membership}</h1>
										<div className="membership-price-container">
											<h3 className="membership-price-typography">${item.price}</h3>
											<h3 className="membership-sale-typography">${item.sale()}</h3>
										</div>
									</div>
									<ul className="tier-list">
										{item.perks.map((item, id) => {
											return (
												<div key={id}>
													<li className="tier-item">{item}</li>
												</div>
											);
										})}
									</ul>
								</div>
							</Bookmark>
						);
					})}
				</div>
			</div>
		</React.Fragment>
	);
};

export default Membership;
